import { Button } from "@material-ui/core";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function QuoteSuccess(props) {

  const mswsHost = process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST ? process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST : 'https://ideas-qa07.msdwis.com';
    const getExpectText =(isIllustration) =>{
        if(isIllustration){
            return(
                <ol>
                  <li>Your Covr insurance team will contact you at the time selected to complete the illustration design process.</li>
                  <li>Once the design process is complete, our team will prepare a formal proposal for your client and deliver the proposal to you via e-mail within two business days.</li>
            </ol>
            )
        }
        else{
            return (
                <ol>
                <li>Please complete the ticket in ITS and submit for supervisory approval.</li>
                <li>Upon approval, your Covr Insurance team will complete the client interview process and submit the application.</li>
                <li>Final rates are determined by the carrier based on the client's specific health class and financial information.</li>
                <li>Policy approval and delivery typically takes 6-8 weeks.</li>
            </ol>
            )
        }
    }

    /* QA07 */
    const NavigateToInsuranceTicketingSystem = (caseNumber) => {
      var ITSDirectURL = `${mswsHost}/threedweb/3d.html?caseNumber=${caseNumber}&mode=0#appid=99735`;
        //if (mswm) {
        //  console.log("mswm found");
        //  if (mswm.ast && mswm.ast.udjsapi && mswm.ast.udjsapi.environment && mswm.ast.udjsapi.environment.isUdContainerAvailable()) {
        //    console.log("redirecting to 99683");
        //    mswm.ast.udjsapi.navigator.navigate("99683", {
        //      GetParameters: "caseNumber=" + caseNumber + "&mode=0"
        //    });
        //  }
        //}
        //else {
          console.log("mswm not found, redirect using direct url");
          window.open(ITSDirectURL, '_blank');
        //}
    }

    return (
        <Container>
            <Row className="mt-3">
                {!props.isIllustration && <div>
                    Your client application request has been received by Covr.
                    <h3><b>Proceed to the Insurance Ticketing System (ITS) to complete your ticket</b></h3>
                </div>}
                {
                    props.isIllustration &&
                    <div>
                        Thank you. Your request for illustrations has been submitted.
                    </div>
                }
            </Row>
            <Row className="mt-2">
                {
                    props.isIllustration &&
                    <Col md={3} className="pl-0">
                        <Button variant="contained" className='w-100' size="large" color="primary" onClick={() => props.clearFormState()}>Request Another Illustration</Button>
                    </Col>
                }
                {!props.isIllustration &&
                    <React.Fragment>
                        <Col md={3} className="pl-0">
                            <Button type="submit" variant="contained" className='w-100' size="large" color="primary" onClick={() => NavigateToInsuranceTicketingSystem(props.yourInformation.caseNumber)}>Complete Ticket in ITS</Button>
                        </Col>
                        <Col md={3}>
                            <Button type="submit" variant="contained" className='w-100' size="large" color="primary" onClick={() => props.clearFormState()}>Submit Another Quote</Button>
                        </Col>
                    </React.Fragment>
                }
            </Row>
            <Row className="mt-4">
                <Col md={6}>
                    <Row><b>{!props.isIllustration && 'Ticket Details'}</b></Row>
                    <Row>
                        {!props.isIllustration &&
                            <React.Fragment>
                                <Col className="pl-0" md={6}>
                                    ITS Number:
                                    <br />
                                    <b><a className="BlueLink" href="#" onClick={() => NavigateToInsuranceTicketingSystem(props.yourInformation.caseNumber)}>{props.yourInformation.caseNumber}</a></b>
                                </Col>
                            </React.Fragment>
                        }
                        <Col className="pl-0" md={6}>
                            {props.isIllustration ? 'Reference ID:' : 'Reference Number:'}
                            <br />
                            <b><a className="BlueLink" target="_blank" href={`/ActivityCenter/${props.yourInformation.referenceID}`}>{props.yourInformation.referenceID} </a></b>
                        </Col>
                    </Row>
                    <Row Style="height:25px"></Row>
                    <Row>
                        <br />
                        {!props.isIllustration ? <b>Covr cannot contact your client until this order is finalized and approved in ITS.</b>: 'If you have any further questions or needs, please contact us at 844-201-6080'}
                         <br />
                        {!props.isIllustration ? "Note: If the details of this order change in the course of the transaction, a new ticket will be required in the ITS.":
                         <span>Please note the representative has to be licensed & appointed in order to submit an insurance ticket. Please refer to MS licensing policy <a target="_blank" href="http://mssbintranet.msdwis.com/uiplsds/app-bin/templatedata/category/HTML_Content/data/Operations/General/Insurance/Licensing/INS_MSPolicy.dcr">here</a> prior to submitting the insurance case.</span>
                        }
                    </Row>
                </Col>
                <Col md={6}>
                    <div className="ml-4"><b>What to Expect</b></div><br />
                    <div>
                         {getExpectText(props.isIllustration)}
                    </div>
                </Col>
            </Row>
        </Container>
    )
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SubComponents/QuoteSuccess.js